const Report = () =>
  import(
    /* webpackChunkName: "log-web-service" */ '@/pages/log/web-service/index.vue'
  )

const Detail = () =>
  import(
    /* webpackChunkName: "log-web-service" */ '@/pages/log/web-service/detail.vue'
  )

export default {
  path: 'web-service',
  meta: { label: 'webService' },
  component: {
    name: 'WebServiceLog',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LogWebServiceReport',
      path: '',
      meta: { label: 'report' },
      component: Report
    },
    {
      name: 'LogDetailWebService',
      path: 'detail/:id',
      meta: { label: 'detail' },
      component: Detail,
      props: true
    }
  ]
}
